/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {SegmentModel} from './segment-api.service';
import {SegmentEditPageComponent} from './segment-edit-page.component';
import {SegmentSidePanelComponent} from './segment-side-panel.component';

@Component({
  standalone: true,
  imports: [SegmentEditPageComponent, SegmentSidePanelComponent],
  selector: 'adn-segment-item-page',
  template: `
    <div class="row">
      <section class="col-sm-6">
        <adn-segment-edit-page [state]="state"></adn-segment-edit-page>
      </section>
      <section class="col-sm-6">
        <adn-segment-side-panel [model]="state.model()" [isNew]="state.isNew()"></adn-segment-side-panel>
      </section>
    </div>
  `
})
export class SegmentItemPageComponent {
  @Input() state: SignalAdminResourcePageState<SegmentModel>;
}
